
function tabSwiper() {
  if (typeof Swiper !== "undefined") {
    const allTabWrapEle = document.querySelectorAll(".tabbed-collection-slider");
    if(allTabWrapEle && allTabWrapEle.length > 0){
      allTabWrapEle.forEach(ele=>{
        const tabButtons = ele.querySelectorAll(`.tab-btn`);
        const tabContents = ele.querySelectorAll(`.tab-content`);
        const swipers = {};
        tabContents.forEach((tab, index) => {
          let swiperEle = tab.querySelector(".product-swiper");
          const swiperId = "#" + swiperEle.getAttribute("id");
          swipers[swiperId] = new Swiper(swiperId, {
            slidesPerView: 4,
            spaceBetween: 20,
            loop: false,
            navigation: {
              nextEl: `${swiperId} .swiper-button-next`,
              prevEl: `${swiperId} .swiper-button-prev`
            },
            breakpoints: {
              320: { slidesPerView: 2, spaceBetween: 10 },
              768: { slidesPerView: 2.5, spaceBetween: 15 },
              1024: { slidesPerView: 4, spaceBetween: 0 }
            }
          });
        });
        tabButtons.forEach((btn) => {
          btn.addEventListener("click", () => {
            tabButtons.forEach(b => b.classList.remove("active"));
            tabContents.forEach(c => c.classList.remove("active"));

            btn.classList.add("active");
            const targetId = btn.dataset.tab;
            const targetTab = document.getElementById(targetId);
            targetTab.classList.add("active");

            // Update swiper for active tab
            const swiperEl = targetTab.querySelector(".swiper");
            if (swiperEl && swipers[`#${swiperEl.id}`]) {
              swipers[`#${swiperEl.id}`].update();
            }
          });
        });
      })
    }
  }else{
    setTimeout(tabSwiper, 100);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  tabSwiper();
  // productItemJs();
});

function productItemJs() {
  const miniCart = document.querySelector('.floating-mini-cart');
  const miniImages = miniCart.querySelector('.mini-cart-images');
  const miniCount = miniCart.querySelector('.mini-cart-count');

  // Always load cart state on refresh
  updateMiniCart();
  window.updateMiniCart = () => {
    updateMiniCart();
  }
  // Add click event to open side cart
  miniCart.addEventListener('click', function(){
    // Adjust selector to your side cart trigger
    const sideCartBtn = document.querySelector('#HeaderCartTrigger');
    if (sideCartBtn) sideCartBtn.click();
  });

  // Called after add-to-cart or on page load
  async function updateMiniCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      let cartCountEle = document.querySelector('.cart-link__bubble .cart-link__bubble-num');
      let cartCountParent = document.querySelector('.cart-link__bubble');
      cartCountParent.classList.add('cart-link__bubble--visible');
      cartCountEle.textContent = count;
      if (count > 0) {
        const items = cart.items.slice(0,3);
        miniImages.innerHTML = '';
        let newItems = items.reverse();
        newItems.forEach((item, i) => {
          miniImages.insertAdjacentHTML('beforeend', 
            `<img src="${item.image}" alt="${item.title}">`
          );
        });

        miniCount.textContent = `${count} ${count == 1 ? Shopify.locale == 'ar' ? 'المنتج' :'item' : Shopify.locale == 'ar' ? 'المنتجات' :'items'}`;
        
        miniCart.style.display = 'flex';
        miniCart.classList.add('visible');
      } else {
        miniCart.style.display = 'none';
      }
    } catch (err) {
      console.error('Mini cart fetch error', err);
    }
  }

  // Reuse from previous snippet: after AJAX add
  // document.body.addEventListener('click', async function(e){
  //   const btn = e.target.closest('.product-item-atc-btn');
  //   if (!btn) return;
  //   e.preventDefault();
  //   const id = btn.dataset.id;

  //   btn.disabled = true;
  //   if(Shopify.locale == 'ar'){
  //     btn.innerText = 'جارٍ الإضافة';
  //   }else{
  //     btn.innerText = 'Adding...';
  //   }

  //   try {
  //     let responseJson = await fetch('/cart/add.js', {
  //       method:'POST',
  //       headers:{'Content-Type':'application/json'},
  //       body:JSON.stringify({id:id, quantity:1})
  //     });
  //     document.dispatchEvent(new CustomEvent('cart:build'));
  //     // this.dispatchEvent(
  //     //   new CustomEvent(EVENTS.ajaxProductAdded, {
  //     //     bubbles: true,
  //     //     detail: {
  //     //       product: responseJson,
  //     //       addToCartBtn: this.querySelector(
  //     //         `#ProductSubmitButton-${this.dataset.sectionId}`
  //     //       ),
  //     //     },
  //     //   })
  //     // );
  //     if(Shopify.locale == 'ar'){
  //       btn.innerText = 'تمّت الإضافة';
  //     }else{
  //       btn.innerText = 'Added!';
  //     }
  //     setTimeout(()=>{
  //       if(Shopify.locale == 'ar'){
  //         btn.innerText = 'أضف إلى السلة';
  //       }else{
  //         btn.innerText='Add To Cart';
  //       }
  //       btn.disabled=false;
  //     },1200);
  //     updateMiniCart(); // refresh mini cart immediately
  //   } catch(err){
  //     console.error(err);
  //     btn.innerText='Error';
  //     setTimeout(()=>{
  //       if(Shopify.locale == 'ar'){
  //         btn.innerText = 'أضف إلى السلة';
  //       }else{
  //         btn.innerText='Add To Cart';
  //       }
  //       btn.disabled=false;
  //     },1200);
  //   }
  // });
}
